import api from "../..";
import type { CategoryDetail, GetCategoryParams, Category, CategoryGraphItem, GetCategoriesAllParams, CategoryListItem, GetCategorySearchParams } from "./types";
import type { ApiResponse } from "../../types";

export const getCategoryById = async ({ id }: GetCategoryParams): Promise<CategoryDetail | null> => {

  return await api.get<ApiResponse<CategoryDetail>>(`/categories/${id}/`)
  .then(res => res.data.data)
  .catch(() => {return null});
};

const transformGraphItem = (item: CategoryGraphItem): Category => {
  return {
    id: item.id,
    title: item.title,
    slug: item.slug,
    depth: item.depth,
    children: Array.isArray(item.children)
      ? item.children.map(transformGraphItem)
      : undefined
  };
};

export const getCategoriesAll = async ({ params }: GetCategoriesAllParams = {}): Promise<Category[]> => {

  const queryParams = new URLSearchParams();

  if (params) {
    Object.entries(params).forEach(([key, value]) => {
      if (Array.isArray(value)) {
        value.forEach(v => queryParams.append(key, v.toString()));
      } else if (value !== undefined) {
        queryParams.append(key, value.toString());
      }
    });
  }

  return await api.get<ApiResponse<CategoryGraphItem[]>>(`/categories/graph/${queryParams.toString() ? "?" + queryParams.toString() : ""}`)
  .then((res) => {return res.data.data.map(transformGraphItem)})
  .catch(() => {return []});
};

export const getCategorySearch = async ({ params }: GetCategorySearchParams = {}): Promise<CategoryListItem[]> => {

  const queryParams = new URLSearchParams();

  if (params) {
    Object.entries(params).forEach(([key, value]) => {
      if (Array.isArray(value)) {
        value.forEach(v => queryParams.append(key, v.toString()));
      } else if (value !== undefined) {
        queryParams.append(key, value.toString());
      }
    });
  }

  return await api.get<ApiResponse<CategoryListItem[]>>(`/categories/${queryParams.toString() ? "?" + queryParams.toString() : ""}`)
  .then(res => res.data.data)
  .catch(() => {return []});
};